module.exports = __webpack_public_path__ + "static/media/silvy_coral_wordmark.6ea11abb.svg";